import { Catalog, CatalogContext } from "@/components/Catalog";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { loadInitialData } from "./util";

window.addEventListener("DOMContentLoaded", () => {
  loadInitialData("catalog", (data, domNode, rootNodeId) => {
    const { oois, activity } = data;
    hydrateRoot(
      domNode,
      <StrictMode>
        <CatalogContext.Provider value={{ oois, rootNodeId }}>
          <Catalog activity={activity} />
        </CatalogContext.Provider>
      </StrictMode>
    );
  });
});
